import { ReducerCreators } from '@reduxjs/toolkit';

import { ProjectsState } from '../types';
import clearProjectsReducer from './clear-projects-reducer';
import loadProjectsReducer from './load-projects-reducer';
import setGetProjectOptionsReducer from './set-get-project-options';
import loadProjectsListForSeriesReducer from './load-projects-list-for-series';
import setGetProjectListForSeriesOptionsReducer from './set-get-project-list-for-series-options';
import deleteProjectReducer from './delete-project';
import setProjectTodDeleteReducer from './set-project-to-delete';
import setProjectToEditReducer from './set-project-to-edit-reducer';
import duplicateProjectReducer from './duplicate-project-reducer';
import loadProjectsListReducer from './load-projects-list-reducer';
import loadProjectGroupsReducer from './load-project-groups-reducer';
import setSelectedProjectGroupReducer from './set-selected-project-group-reducer';
import setProjectsDisplayViewReducer from './set-projects-display-view-reducer';
import createProjectGroupReducer from './create-project-group-reducer';
import updateProjectGroupReducer from './update-project-group-reducer';
import deleteProjectGroupReducer from './delete-project-group-reducer';
import clearGroupErrorReducer from './clear-group-error-reducer';
import setGroupToDeleteReducer from './set-group-to-delete-reducer';
import setGroupToEditReducer from './set-group-to-edit-reducer';
import setShowCreateGroupModalReducer from './set-show-create-group-modal-reducer';
import addProjectsToGroupReducer from './add-projects-to-group-reducer';
import setAddProjectsToGroupReducer from './set-add-projects-to-group-reducer';
import loadProjectGroupTreeReducer from './load-project-group-tree-reducer';
import modifyProjectGroupsForAdminReducer from './modify-project-groups-for-admin-reducer';

export const reducers = (create: ReducerCreators<ProjectsState>) => ({
  clearProjects: clearProjectsReducer(create),
  loadProjects: loadProjectsReducer(create),
  loadProjectsListForSeries: loadProjectsListForSeriesReducer(create),
  setGetProjectOptions: setGetProjectOptionsReducer(create),
  setGetProjectListForSeriesOptions: setGetProjectListForSeriesOptionsReducer(create),
  deleteProject: deleteProjectReducer(create),
  setProjectToDelete: setProjectTodDeleteReducer(create),
  setProjectToEdit: setProjectToEditReducer(create),
  duplicateProject: duplicateProjectReducer(create),
  loadProjectsList: loadProjectsListReducer(create),
  loadProjectGroups: loadProjectGroupsReducer(create),
  setSelectedProjectGroup: setSelectedProjectGroupReducer(create),
  setProjectsDisplayView: setProjectsDisplayViewReducer(create),
  createProjectGroup: createProjectGroupReducer(create),
  updateProjectGroup: updateProjectGroupReducer(create),
  deleteProjectGroup: deleteProjectGroupReducer(create),
  clearGroupError: clearGroupErrorReducer(create),
  setGroupToDelete: setGroupToDeleteReducer(create),
  setGroupToEdit: setGroupToEditReducer(create),
  setShowCreateGroupModal: setShowCreateGroupModalReducer(create),
  addProjectsToGroup: addProjectsToGroupReducer(create),
  setAddProjectsToGroup: setAddProjectsToGroupReducer(create),
  loadProjectGroupTree: loadProjectGroupTreeReducer(create),
  modifyProjectGroupsForAdmin: modifyProjectGroupsForAdminReducer(create),
});
